<template>
  <v-dialog v-model="dialogShow" :max-width="formDialogOptions.width" hide-overlay>
    <v-card elevation="10">
      <v-card-title>
        <v-row class="yellow darken-2 rounded text-center">
          <v-col cols="12">
            <div class="subtitle-1text--darken-2 font-weight-black text-uppercase ma-n2">
              <span  class="blue--text" >
              {{ itemModified.description }}
              </span>
            </div>
            <div v-if="itemModified.calcData">
              <div class="subtitle-1 font-weight-black mt-2">
                <div v-if="itemModified.calcData.nilaiAkhir" >
                  {{ formatter(itemModified.calcData.nilaiAkhir) }}
                </div>
              </div>
              <div class="subtitle-2 font-weight-regular">
                <span class="mr-1" v-if="itemModified.calcData.tahunPalingAkhir">{{itemModified.calcData.tahunPalingAkhir}}</span>
                <span  v-if="itemModified.calcData.sumberAkhir">*{{ itemModified.calcData.sumberAkhir }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div v-if="series1.length===1">
              <div class="headline my-3 blue--text text--darken-2 text-center">
                <span>{{ itemModified.description }} {{itemModified.calcData.tahunPalingAkhir}}</span> =
                <span class="font-weight-bold">{{ formatter(itemModified.calcData.nilaiAkhir) }}</span>
              </div>
            </div>
            <div v-else>
              <DayaDukungBannerChartPie
                  chartType="pie"
                  :dialogWidth="formDialogOptions.width"
                  :series1="series1"
                  :labels1="labels1"
                  :itemModified="itemModified"
              ></DayaDukungBannerChartPie>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-if="series2.length===1">
              <div class="headline my-3 blue--text text--darken-2  text-center">
                <span>{{ itemModified.description }} {{itemModified.calcData.tahunPalingAkhir}}</span> =
                <span class="font-weight-bold">{{ formatter(itemModified.calcData.nilaiAkhir) }}</span>
              </div>
            </div>
            <div v-else>
              <DayaDukungBannerChartTrend
                  chartType="bar"
                  :dialogWidth="formDialogOptions.width"
                  :series1="series2"
                  :labels1="labels2"
                  :itemModified="itemModified"
              ></DayaDukungBannerChartTrend>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DayaDukungBannerChartPie from "@/components/public-daya-dukung-banner/DayaDukungBannerChartPie.vue";
import DayaDukungBannerChartTrend from "@/components/public-daya-dukung-banner/DayaDukungBannerChartTrend.vue";
export default {
  name: "DayaDukungBannerDialog",
  components: {
    DayaDukungBannerChartTrend,
    DayaDukungBannerChartPie
  },
  props: {
    itemsFDayaDukung: Array,
  },
  data() {
    return {
      title: "",

      dialogShow: false,
      formDialogOptions: {
        title1: "",
        title2: "",
        message1: "",
        message2: "",
        errorMessage: "",
        color: "grey lighten-3",
        width: 800,
        zIndex: 200,
        noconfirm: false,
      },

      series1: [2, 4, 5, 6],
      labels1: ["a", "b", "c", "d"],
      series2: [2, 4, 5, 6],
      labels2: ["a", "b", "c", "d"],
      itemModified: "",
    };
  },
  computed: {
  },
  watch: {},

  methods: {
    showDialog(itemModified) {

      let tahunPalingAkhir = 0;
      let itemsFDayaDukungFiltered = this.itemsFDayaDukung.filter((item) =>item.fdayaDukungTypeBean === itemModified.id);
      itemsFDayaDukungFiltered.forEach((item) => {
        tahunPalingAkhir = Math.max(tahunPalingAkhir, item.tahun);
      });

      this.series1 = []
      this.labels1 = []
      itemsFDayaDukungFiltered.filter(item => item.tahun===tahunPalingAkhir).sort((a, b) => b.nilai1 - a.nilai1).forEach((item) => {
        this.series1.push(item.nilai1)
        this.labels1.push(item.description)
      })




      const yearlyData = {};
      itemsFDayaDukungFiltered.forEach((item) => {
        if (yearlyData[item.tahun]) {
          yearlyData[item.tahun] += item.nilai1;
        } else {
          yearlyData[item.tahun] = item.nilai1;
        }
      });

      this.series2 = []
      this.labels2 = []
      // Mengubah hasil pengelompokan menjadi array
      Object.keys(yearlyData).sort((a, b) => a - b).forEach((year) => {
        this.labels2.push(year);
        this.series2.push(yearlyData[year]);
      });

      this.itemModified = itemModified;
      this.dialogShow = !this.dialogShow;
    },

    formatter: function (val) {
      let value = val
      let valueStr = "";
      if (value / 1000000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000000).toFixed(
            2
        )} Triliun`;
      } else if (value / 1000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000).toFixed(2)} Miliar`;
      } else if (value / 1000000 > 1) {
        valueStr = `${parseFloat(value / 1000000).toFixed(2)} Juta`;
      } else if (value / 1000 > 1) {
        valueStr = `${parseFloat(value / 1000).toFixed(2)} Ribu`;
      } else {
        valueStr = value.toString();
      }
      return valueStr;
    },

    passingEventFromCloseConfirm(value) {
      if (value === "OKE") this.dialogShow = false;
    },
    setDialogState(value) {
      this.dialogShow = value;
    },

  },
};
</script>

<style scoped>
</style>